// Maps raw broker/exchange symbols to human-readable names used across the
// public Track Record UI (row title, expanded details).
// Only "showy" transformations — regular tickers like TSLA, AAPL, BTC/USDT
// pass through unchanged.

const SYMBOL_ALIASES = {
  // Metals futures
  'HG=F': 'CUIVRE',
  'HG1!': 'CUIVRE',
  'GC=F': 'GOLD',
  'GC1!': 'GOLD',
  'SI=F': 'SILVER',
  'SI1!': 'SILVER',
  'PL=F': 'PLATINE',
  'PA=F': 'PALLADIUM',

  // Energy futures
  'CL=F': 'PÉTROLE (WTI)',
  'CL1!': 'PÉTROLE (WTI)',
  'BZ=F': 'BRENT',
  'BZ1!': 'BRENT',
  'NG=F': 'GAZ NATUREL',
  'NG1!': 'GAZ NATUREL',
  'RB=F': 'ESSENCE',
  'HO=F': 'FIOUL',

  // Agricultural futures
  'ZC=F': 'MAÏS',
  'ZS=F': 'SOJA',
  'ZW=F': 'BLÉ',
  'KC=F': 'CAFÉ',
  'CC=F': 'CACAO',
  'SB=F': 'SUCRE',
  'CT=F': 'COTON',

  // Indices
  '^IXIC': 'NASDAQ',
  '^GSPC': 'S&P 500',
  '^DJI': 'DOW JONES',
  '^RUT': 'RUSSELL 2000',
  '^VIX': 'VIX',
  '^FCHI': 'CAC 40',
  '^GDAXI': 'DAX',
  '^FTSE': 'FTSE 100',
  '^N225': 'NIKKEI',
  '^HSI': 'HANG SENG',
  'ES=F': 'S&P 500 (futures)',
  'NQ=F': 'NASDAQ (futures)',
  'YM=F': 'DOW JONES (futures)',
  'RTY=F': 'RUSSELL 2000 (futures)',
};

// Strips common exchange prefixes (NASDAQ:GOOGL → GOOGL, CCC:TRX-USD → TRX-USD → TRX)
// and unifies crypto forms (BTC/USDT → BTC, TRX-USD → TRX).
export const formatSymbolLabel = (symbol) => {
  if (!symbol) return '';
  const raw = String(symbol).trim();

  // Direct alias hit (case-insensitive)
  const upper = raw.toUpperCase();
  if (SYMBOL_ALIASES[upper]) return SYMBOL_ALIASES[upper];

  // Strip exchange prefix like NASDAQ:GOOGL, NYSE:XYZ, BINANCE:BTCUSDT, CCC:LTC-USD
  const withoutExchange = raw.includes(':') ? raw.split(':').slice(-1)[0] : raw;

  // Crypto pair variants → keep only the base (BTC/USDT, LTC-USD, BTC-USD)
  const cryptoMatch = withoutExchange.match(/^([A-Z0-9]+)[\/\-](USDT|USD|USDC|BUSD|BTC|ETH)$/i);
  if (cryptoMatch) return cryptoMatch[1].toUpperCase();

  // Alias hit on the cleaned form (e.g. after stripping exchange)
  const cleaned = withoutExchange.toUpperCase();
  if (SYMBOL_ALIASES[cleaned]) return SYMBOL_ALIASES[cleaned];

  return cleaned;
};

export default formatSymbolLabel;
